<template>
    <Teleport v-if="canTeleport" to="body">
        <Transition name="more-sheet">
            <div
                v-if="open"
                id="mobile-more-sheet"
                class="more-sheet"
                role="dialog"
                aria-modal="true"
                aria-label="Дополнительное меню"
            >
                <button
                    type="button"
                    class="more-sheet__backdrop"
                    aria-label="Закрыть меню"
                    @click="$emit('close')"
                />
                <div class="more-sheet__panel">
                    <div class="more-sheet__handle" aria-hidden="true" />
                    <header class="more-sheet__header">
                        <p class="more-sheet__title">Разделы</p>
                        <button
                            type="button"
                            class="more-sheet__close"
                            aria-label="Закрыть"
                            @click="$emit('close')"
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.75" stroke-linecap="round"/>
                            </svg>
                        </button>
                    </header>

                    <nav class="more-sheet__nav">
                        <Link
                            v-for="item in publicLinks"
                            :key="item.href"
                            :href="item.href"
                            class="more-sheet__link"
                            :class="{ 'is-active': isActive(item.href) }"
                            @click="$emit('close')"
                        >
                            <span class="more-sheet__link-main">
                                <img
                                    v-if="item.icon"
                                    :src="item.icon"
                                    alt=""
                                    class="more-sheet__link-icon"
                                    width="20"
                                    height="20"
                                    decoding="async"
                                />
                                <span class="more-sheet__link-label">{{ item.label }}</span>
                            </span>
                            <svg class="more-sheet__chevron" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                                <path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </Link>
                    </nav>

                    <div class="more-sheet__section">
                        <p class="more-sheet__section-title">Аккаунт</p>
                        <template v-if="authUser">
                            <template v-if="authUser.is_admin">
                                <Link
                                    v-for="item in adminLinks"
                                    :key="item.href"
                                    :href="item.href"
                                    class="more-sheet__link"
                                    :class="{ 'is-active': isActive(item.href) }"
                                    @click="$emit('close')"
                                >
                                    <span class="more-sheet__link-label">{{ item.label }}</span>
                                </Link>
                            </template>
                            <template v-else>
                                <Link
                                    href="/profile"
                                    class="more-sheet__link"
                                    :class="{ 'is-active': isActive('/profile') }"
                                    @click="$emit('close')"
                                >
                                    <span class="more-sheet__link-label">Мой профиль</span>
                                </Link>
                                <Link
                                    v-if="authUser.status === 'registered'"
                                    href="/player/stats"
                                    class="more-sheet__link"
                                    :class="{ 'is-active': isActive('/player/stats') }"
                                    @click="$emit('close')"
                                >
                                    <span class="more-sheet__link-label">Статистика</span>
                                </Link>
                            </template>
                            <button type="button" class="more-sheet__link more-sheet__link--danger" @click="logout">
                                <span class="more-sheet__link-label">Выйти</span>
                            </button>
                        </template>
                        <Link
                            v-else
                            href="/login"
                            class="more-sheet__link more-sheet__link--accent"
                            @click="$emit('close')"
                        >
                            <span class="more-sheet__link-label">Войти</span>
                        </Link>
                    </div>
                </div>
            </div>
        </Transition>
    </Teleport>
</template>

<script setup>
import { Link, router, usePage } from '@inertiajs/vue3';
import { computed, watch, onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
    open: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['close']);
const canTeleport = ref(false);

onMounted(() => {
    canTeleport.value = true;
});

const page = usePage();
const authUser = computed(() => page.props.auth?.user || null);

const publicLinks = [
    { href: '/players', label: 'Игроки' },
    { href: '/coaches', label: 'Тренеры' },
    { href: '/referees', label: 'Судьи' },
    { href: '/stats/advanced', label: 'Для продвинутых', icon: '/images/icons/flammable.png' },
];

const adminLinks = [
    { href: '/admin/dvw', label: 'Загрузить матч' },
    { href: '/admin/sheets-sync', label: 'Sheets Sync' },
];

const isActive = (path) => {
    const current = page.url.split('?')[0];
    if (path === '/') return current === '/';
    return current === path || current.startsWith(path + '/');
};

const logout = () => {
    emit('close');
    router.post('/logout', {}, {
        preserveScroll: false,
        preserveState: false,
    });
};

watch(
    () => props.open,
    (isOpen) => {
        if (typeof document === 'undefined') return;
        document.body.style.overflow = isOpen ? 'hidden' : '';
    }
);

onUnmounted(() => {
    if (typeof document !== 'undefined') {
        document.body.style.overflow = '';
    }
});
</script>
